import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trailersAPI } from "components/Apis/assets";

export const fetchTrailers = createAsyncThunk(
    'trailers/fetchTrailers',
    async (
        {
            page = 1,
            pageSize = 10,
            search = '',
            ordering = 'last_update',
            groupBy = null,
            available = null,
        } = {},
        { rejectWithValue }
    ) => {
        try {
            const response = await trailersAPI.getTrailers(page, pageSize, { search, ordering, groupBy, available });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const fetchTrailersForTerminal = createAsyncThunk(
    'trailers/fetchTrailersForTerminal',
    async (terminalName, { rejectWithValue }) => {
        try {
            const response = await trailersAPI.getTrailerForTerminal(terminalName);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

const trailersSlice = createSlice({
    name: 'trailers',
    initialState: {
        list: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTrailers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTrailers.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload;
            })
            .addCase(fetchTrailers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchTrailersForTerminal.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTrailersForTerminal.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload;
            })
            .addCase(fetchTrailersForTerminal.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default trailersSlice.reducer;
